"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.daysNumberToTag = exports.daysTagToNumber = void 0;

var _immutable = require("immutable");

var _constants = require("settings-ui-sdk/EmailFrequency/constants");

var daysTagToNumber = function daysTagToNumber(tag) {
  var tagInNumberFormat = Number(tag);

  if (tagInNumberFormat) {
    return "" + tagInNumberFormat;
  }

  switch (tag) {
    case _constants.TIMEFRAME.DAILY:
      return '1';

    case _constants.TIMEFRAME.WEEKLY:
      return '7';

    case _constants.TIMEFRAME.BIWEEKLY:
      return '14';

    case _constants.TIMEFRAME.MONTHLY:
      return '28';

    default:
      return '7';
  }
};

exports.daysTagToNumber = daysTagToNumber;

var daysNumberToTag = function daysNumberToTag(days) {
  var tagInNumberFormat = Number(days);

  if (tagInNumberFormat) {
    switch ("" + tagInNumberFormat) {
      case '1':
        return _constants.TIMEFRAME.DAILY;

      case '7':
        return _constants.TIMEFRAME.WEEKLY;

      case '14':
        return _constants.TIMEFRAME.BIWEEKLY;

      case '28':
        return _constants.TIMEFRAME.MONTHLY;

      default:
        return _constants.TIMEFRAME.WEEKLY;
    }
  } else if (typeof days == 'string') {
    var periods = new _immutable.Set(Object.keys(_constants.TIMEFRAME));

    if (periods.has(days)) {
      return days;
    }
  }

  return _constants.TIMEFRAME.WEEKLY;
};

exports.daysNumberToTag = daysNumberToTag;